const DELETE_Booking_PROPERTIES_URL = '/delete-booking-customer-property';
const SAVE_PROPERTY_FIELD = '/property/save-property-fields';
const GET_PROPERTIES = '/booking/get-booking-property-custom';
function buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;
        formData.append(parentKey, value);
    }
}

module.exports = {

    deleteBookingProperties: function deleteBookingProperties(toBeDeletedProperty) {
        let form = new FormData();
        form.set('id', toBeDeletedProperty.id);
        return window.axios.post(DELETE_Booking_PROPERTIES_URL, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    updateBookingProperty:function updateBookingProperty (data){
        let form = new FormData();

        buildFormData(form, data);

        return window.axios.post(SAVE_PROPERTY_FIELD, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    getBookingProperty:function getBookingProperty (id){
        return window.axios.get(GET_PROPERTIES + '/' + id, {});
    },

};